interface CompaniaFormColoresBotonesProps {
    register: any;
    watch: any;
}

export const CompaniaFormColoresBotones = ({ register, watch }: CompaniaFormColoresBotonesProps) => {
    return (
        <>
            <h6 className="px-2">Colores de botones</h6>

            <div className="col-12 col-lg-4">
                <div className="row g-3">
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Botón primario</label>
                            <input
                                {...register("color_button_primario")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Botón primario activo</label>
                            <input
                                {...register("color_button_primario_hover")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Texto del botón primario</label>
                            <input
                                {...register("color_button_primario_texto")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 col-lg-2 d-flex justify-content-center align-items-center">
                <div className="p-3 border">
                    <button
                        className="btn btn-sm btn-primario"
                        type="button"
                        style={{ background: watch("color_button_primario"), color: watch("color_button_primario_texto") }}
                        onMouseEnter={(e) => {
                            // Cambiar el color de fondo y el color del texto en hover
                            e.currentTarget.style.backgroundColor = watch("color_button_primario_hover"); // Color de fondo en hover
                            e.currentTarget.style.color = watch("color_button_primario_texto"); // Color de texto en hover
                        }}
                        onMouseLeave={(e) => {
                            // Volver a los estilos predeterminados al dejar de hacer hover
                            e.currentTarget.style.backgroundColor = watch("color_button_primario"); // Color de fondo predeterminado
                            e.currentTarget.style.color = watch("color_button_primario_texto"); // Color de texto predeterminado
                        }}

                    >Guardar</button>
                </div>

            </div>

            <div className="col-12 col-lg-4">
                <div className="row g-3">
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Botón secundario</label>
                            <input
                                {...register("color_button_secundario")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Botón secundario activo</label>
                            <input
                                {...register("color_button_secundario_hover")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Texto del botón secundario</label>
                            <input
                                {...register("color_button_secundario_texto")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 col-lg-2 d-flex justify-content-center align-items-center">
                <div className="p-3 border">
                    <button
                        className="btn btn-sm btn-secundario"
                        type="button"
                        style={{ background: watch("color_button_secundario"), color: watch("color_button_secundario_texto") }}
                        onMouseEnter={(e) => {
                            // Cambiar el color de fondo y el color del texto en hover
                            e.currentTarget.style.backgroundColor = watch("color_button_secundario_hover"); // Color de fondo en hover
                            e.currentTarget.style.color = watch("color_button_secundario_texto"); // Color de texto en hover
                        }}
                        onMouseLeave={(e) => {
                            // Volver a los estilos predeterminados al dejar de hacer hover
                            e.currentTarget.style.backgroundColor = watch("color_button_secundario"); // Color de fondo predeterminado
                            e.currentTarget.style.color = watch("color_button_secundario_texto"); // Color de texto predeterminado
                        }}
                    >
                        Cancelar
                    </button>
                </div>

            </div>
        </>
    );
};
